import { isReaderRoute } from "../../../utils/isReaderRoute";

export const getCurrentArea = (
  pathname: string,
  showEndInterstitial: boolean,
) => {
  if (isReaderRoute(pathname)) {
    if (showEndInterstitial) return "interstitial";
    return "consumption";
  }
  if (pathname.startsWith("/cms/")) return "view-all";
  if (pathname.includes("/originals")) return "gc-originals";
  if (pathname.includes("/books")) return "books";
  if (pathname.includes("/creators")) return "creators";
  if (pathname.includes("/browse")) return "browse";
  if (pathname === "/" || pathname.includes("/channel")) return "home";
  if (pathname.includes("/library")) return "library";
};
